'use client'

import styled from '@emotion/styled'
import DownloadIcon from '@mui/icons-material/Download'
import Box from '@mui/material/Box'
import MuiButton from '@mui/material/Button'
import Container from '@mui/material/Container'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { motion } from 'framer-motion'
import StoreBadges from '~/app/_components/badges'

const Section = styled.section`
  padding: 96px 0;
  background: #ffffff;
  position: relative;
  overflow: hidden;
`

const GridPattern = styled.div`
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(to right, rgba(128, 128, 128, 0.03) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(128, 128, 128, 0.03) 1px, transparent 1px);
  background-size: 4rem 4rem;
  pointer-events: none;
`

const Badge = styled(Box)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(39, 177, 198, 0.1);
  border: 1px solid rgba(39, 177, 198, 0.2);
  border-radius: 9999px;
  padding: 6px 20px;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #0e7490;
  margin-bottom: 24px;
`

export default function AppDownloadCTA() {
  return (
    <Section>
      <GridPattern />
      <Container maxWidth='lg' sx={{ position: 'relative', zIndex: 1 }}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Box sx={{ maxWidth: 800, mx: 'auto', textAlign: 'center' }}>
            <Badge>Get Started</Badge>

            <Typography
              variant='h3'
              sx={{ fontWeight: 700, mb: 3, color: '#171717' }}
            >
              Start Trading with AI Today
            </Typography>

            <Typography
              sx={{
                color: '#6b7280',
                fontSize: '1.125rem',
                maxWidth: 600,
                mx: 'auto',
                mb: 5,
              }}
            >
              Download our mobile app and access advanced neural network trading
              technology directly from your smartphone
            </Typography>

            <MuiButton
              component={Link}
              href='/get-app'
              variant='contained'
              size='large'
              startIcon={<DownloadIcon />}
              sx={{
                backgroundColor: '#0e7490',
                px: 6,
                py: 2,
                fontSize: '1.125rem',
                textTransform: 'none',
                boxShadow: '0 4px 16px rgba(14, 116, 144, 0.3)',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#155e75',
                  boxShadow: '0 6px 20px rgba(14, 116, 144, 0.4)',
                  color: 'white',
                },
                mb: 5,
              }}
            >
              Download App
            </MuiButton>

            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
              <StoreBadges variant='light' />
            </Box>

            <Typography variant='caption' sx={{ color: '#9ca3af' }}>
              Available on App Store and Google Play • Research-backed
              methodology
            </Typography>
          </Box>
        </motion.div>
      </Container>
    </Section>
  )
}
